<template>
  <!--导航栏-->
  <div id="nav">
    <!--1200px版心-->
    <div class="banxin">
      <!--logo-->
      <p class="logo fl">
        <img src="/static/img/logo_new.png" />
      </p>
      <!--导航-->
      <ul class="dh">
        <li :class="{xuanzhong:$route.name==='index'}">
          <router-link to="/index">首页</router-link>
        </li>

        <li :class="{xuanzhong:$route.name==='news' || $route.name==='new_detail'}">
          <router-link to="/news">新闻中心</router-link>
        </li>

        <li :class="{xuanzhong:$route.name==='about'}">
          <router-link to="/about">关于我们</router-link>
        </li>
        <!--<li>-->
          <!--<a target="_blank" href="http://www2.au-express.com">旧版系统</a>-->
        <!--</li>-->
      </ul>

      <!--
                右漂浮  登录注册签到
              -->
      <ul class="dlzc login fr" v-if="userToken">
        <li>
          <router-link to="/user">个人中心
          </router-link>
        </li>
        <li>
          <a href="javascript:;" @click="logout">登出</a>
        </li>
      </ul>
      <ul class="dlzc fr" v-else >
        <li>
          <router-link to="/login">企业后台登录</router-link>
        </li>
        <!--<li>-->
          <!--<router-link to="/register">注册</router-link>-->
        <!--</li>-->
      </ul>

    </div>
    <!--版心结束-->
  </div>
  <!--导航结束-->
</template>
<script>
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters([
        'name',
        'avatar',
        'userToken'
      ])
    },
    methods: {
      logout(){
        this.$store.dispatch('LogOut').then(() => {
          location.reload(); // 为了重新实例化vue-router对象 避免bug
        });
      },
    }
  };
</script>
<style rel="stylesheet/scss" lang="scss">

  #nav{
    width: 100%;
    height: 98px;
    background-color: white;
    border-bottom: 1px solid #c2c2c2;
    position:relative;
    font-size: 14px;
    font-family: "微软雅黑";
    z-index: 100;
  
    .banxin{
      .dh{
        margin-left: 400px;
        padding-top: 34px;
      }
      .logo{
        width: 198px;
        height: 70px;
        margin-left: 60px;
        padding-top: 14px;
      }
  
      .dh {
        li {
          width: 90px;
          height: 30px;
          /*background-color: red;*/
          border-radius: 15px;
          margin-right: 30px;
          text-align:center;
          line-height: 30px;
          float: left;
          color: #333333;
          a{
            display: block;
          }
          &:hover{
            background-color: red;
            transition: all 0.4s ease-out 0s;
          }
          &:hover>a{
            transition: all 0.2s ease-out 0s;
            color: white;
          }
        }
        
        .xuanzhong{
          background-color: red;
          >a{
            color: white;
          }
        }
      }
      .dlzc{
        font-size: 12px;
        float: right;
        margin-right:50px;
        padding-top: 2px;
        li{
          width: auto;
          padding: 0 10px;
          height: 24px;
          /*box-sizing: border-box;*/
          border: 1px solid red;
          float: left;
          text-align: center;
          line-height: 24px;
          margin-right: 10px;
          border-radius: 4px;
         // background-color: red;
          transition: all 0.4s ease-out 0s;
          a:link,
          a:visited{
            color: red;
          }
        }
        li:hover{
          /*border: none;*/
          background-color: red;
          transition: all 0.4s ease-out 0s;
          >a{
            color: white;
            transition: all 0.2s ease-out 0s;
          }
        }
        
        
      }
    }
    
  }
  #nav a:link,
  #nav a:visited{
    color: #333333;
  }


  .khz{
    width: 100%;
    height: 99px;
  }


</style>


// WEBPACK FOOTER //
// src/views/layout/Nav.vue